import { masterEntitiesData } from './master-entities.data';
import { toMasterCategories, toPriceGroupList, toPriceList, toZoneList } from './master-entities.mappers';

export const masterEntitiesService = {
  getCategoryList: async () => {
    const data = await masterEntitiesData.getCategoryList();

    const mappedData = toMasterCategories(data);

    return mappedData;
  },
  getPriceGroupList: async () => {
    const response = await masterEntitiesData.getPriceGroupList();

    const result = toPriceGroupList(response);

    return result;
  },
  getZoneList: async () => {
    const response = await masterEntitiesData.getZoneList();

    const result = toZoneList(response);

    return result;
  },
  getPriceList: async (selectedPriceGroups?: string) => {
    const response = await masterEntitiesData.getPriceList(selectedPriceGroups);

    const result = toPriceList(response);

    return result;
  },
};
